module.exports = __webpack_public_path__ + "img/background_wave_double.b3d5a03.svg";